import $ from 'jquery';
import 'slick-carousel';
import { loadSVG } from '../utils/load-svg';
import { debounce } from '../utils/debounce';

const sliderRelatedEvents = () => {
	const el = {
		target: '.js-carousel-events',
		loop: { container: '.elementor-loop-container' },
	};

	let $target = $();

	const init = () => {
		$(function () {
			$target = $(el.target).find(el.loop.container);

			if (!$target.length) return;

			$target.find('style').prependTo($target.parent());

			exec();

			$(window).on('resize', debounce(exec, 200));
		});
	};

	function changeArrowBtn(slick) {
		requestAnimationFrame(() => {
			if (slick.$list === null) return;

			loadSVG('/wp-content/uploads/2025/12/ic-arrow-right.svg')
				.then((svgString) => {
					slick.$nextArrow.html(svgString);
				})
				.catch(console.error);

			loadSVG('/wp-content/uploads/2025/12/ic-arrow-left.svg')
				.then((svgString) => {
					slick.$prevArrow.html(svgString);
				})
				.catch(console.error);
		});
	}

	const exec = () => {
		$target.on('init', function (e, slick) {
			changeArrowBtn(slick);
		});

		$target
			.slick({
				adaptiveHeight: false,
				slidesToShow: 1.25,
				infinite: false,
				arrows: true,
				mobileFirst: true,
				responsive: [
					{
						breakpoint: 1024,
						settings: 'unslick',
					},
					{
						breakpoint: 601,
						settings: {
							slidesToShow: 2.25,
						},
					},
				],
			})
			.on('breakpoint reInit', function (e, slick) {
				changeArrowBtn(slick);
			});
	};

	init();
};

try {
	sliderRelatedEvents();
} catch (error) {
	console.error(error);
}
